import { render } from "./IndexEmptyDialog.vue?vue&type=template&id=13ce5359"
import script from "./IndexEmptyDialog.vue?vue&type=script&lang=js"
export * from "./IndexEmptyDialog.vue?vue&type=script&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IndexEmptyDialog.vue"]])

export default __exports__